import { useState } from "react";
import { Button } from "react-bootstrap";
import ProfessionalDesignConsultationModal from "./premium-callback";
import { useCounterStore } from "../../../store/useConterStore";

export default function GetInTouchPopUp({ handleClick }) {
  const { premiumForm, setPremiumForm, setSourceId } = useCounterStore();

  return (
    <div className="premium-callback-container">
      <div
        style={{
          fontWeight: "600",
          letterSpacing: "0.5px",
          fontSize: "20px",
          color: "#FFF8E1",
        }}
        className="premium-callback-title"
      >
        Book a Consultation
      </div>
      <p
        style={{
          lineHeight: "17px",
          fontSize: "13.5px",
          color: "#FFF8E1",
          margin: "4px 0 12px",
        }}
      >
        Get personalized expert advice tailored to your space
      </p>
      <Button
        style={{
          width: "100%",
          backgroundColor: "#FFF8E1",
          color: "#d9a520ff",
          border: "1px solid #FFF8E1",
          borderRadius: "14px",
          fontWeight: "bold",
        }}
        onClick={() => {
          setSourceId("book-an-appointment-floater"); // Set sourceId when button is clicked so we know where the user came from
          setPremiumForm(!premiumForm);
          handleClick();
        }}
      >
        Schedule a Call
      </Button>
      <ProfessionalDesignConsultationModal />
    </div>
  );
}
